import React, { useEffect } from 'react';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';
import './App.scss';
import { connect, ConnectedProps } from 'react-redux';
import {  AppDispatch } from './store';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import CONFIG from './config';
import Themes from './styles/themes';
import PageContainer from './components/PageContainer/PageContainer';
import { bindActionCreators } from 'redux';
import { fetchProduct } from './store/features/product/product';
import { sendWaData } from './utils/Functions';
import { fetchWindowVariables } from './store/features/app/app';

const theme = CONFIG.isUPC ? 'Uplay' : 'Store';

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
  fetchWindowVariables: bindActionCreators(fetchWindowVariables, dispatch),
});

const connector = connect(null, mapDisPatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = ({
               localeId,
               fetchWindowVariables
             }: AppProps) => {
  const localizedContent: IContent = data.filter(
    locale => locale.lang === localeId
  )[0];
  useEffect(() => {
    sendWaData();
    fetchWindowVariables();
  }, [fetchProduct,fetchWindowVariables]);

  return (
    <main id="subscription-rewards">
      <ContentProvider value={localizedContent}>
        <ThemeProvider theme={Themes[theme]}>
          <StyleSheetManager target={document.querySelector("#stylesheetsContainer")} disableCSSOMInjection={true}>
            <PageContainer/>
          </StyleSheetManager>
        </ThemeProvider>
      </ContentProvider>
    </main>
  );
};
export default connector(App);
